import { useJourneyStore, type Quality } from "../game/state/journeyMachine";

const OPTIONS: readonly { value: Quality; label: string }[] = [
  { value: "baja", label: "Baja" },
  { value: "media", label: "Media" },
  { value: "alta", label: "Alta" },
];

export function QualitySelector() {
  const quality = useJourneyStore((s) => s.quality);
  const setQuality = useJourneyStore((s) => s.setQuality);

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-[var(--cale-ink-muted)]">Calidad</span>
      <select
        value={quality}
        onChange={(e) => setQuality(e.target.value as Quality)}
        className="rounded-md border border-[var(--cale-border)] bg-[var(--cale-surface-raised)] px-2 py-1"
        aria-label="Selector de calidad gráfica"
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
